import { createElementBlock, openBlock, createElementVNode } from 'vue';

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 30 50"
};

function render(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", { d: "M1.135 27.986c0-.376 21.593 20.893 21.593 20.893A3.689 3.689 0 0 0 25.38 50a3.69 3.69 0 0 0 2.653-1.121 3.586 3.586 0 0 0 1.134-2.611c0-.986-.41-1.929-1.134-2.61L9.472 25 28.033 6.342a3.586 3.586 0 0 0 1.134-2.611c0-.986-.41-1.929-1.134-2.61a3.468 3.468 0 0 0-2.65-1.12 3.46 3.46 0 0 0-2.655 1.12L1.135 22.013c-1.513 1.867-1.513 4.106 0 5.973Z" }, null, -1)
  ])))
}
const ArrowLeft = { render: render };

export { ArrowLeft as default, render };
